// Library methods
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";

// MUI Components
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import DefaultModal from "../../../../components/UI/DefaultModal";

// Styles
import {
  CustomTextFieldOutlined,
  CustomTextFieldOutlinedInputProps,
  ModalCustomConfirm,
  ModalCustomCancel,
} from "../../../../styles/muiStylesHelper";

const AddUserModal = ({
  rows = [],
  open,
  onClose,
  onConfirm,
  onCancel,
  userEmail,
  setUserEmail,
  clinicName,
}) => {
  // internationalization
  const { t } = useTranslation();
  const [userAlreadyExist, setUserAlreadyExist] = useState(false);
  const [isInValidEmail, setIsInValidEmail] = useState(false);

  const handleChange = useCallback(
    (e) => {
      const val = e.target.value;
      let alreadyExist = false;
      rows.forEach((row) => {
        if (row?.user === val) alreadyExist = true;
      });
      setIsInValidEmail(val && (!val.includes("@") || !val.includes(".")));
      setUserAlreadyExist(alreadyExist);
      setUserEmail(val);
    },
    [rows, setUserEmail]
  );

  useEffect(() => setUserAlreadyExist(false), [open]);

  return (
    <DefaultModal
      isOpen={open}
      onClose={onClose}
      title={t("add_user")}
      maxWidth="xs"
      modalActions={
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          <Button
            variant="text"
            onClick={onCancel}
            sx={ModalCustomCancel}
            style={{ color: "black" }}
          >
            {t("button_cancel")}
          </Button>
          <Button
            data-testid="button_add"
            variant="outlined"
            sx={ModalCustomConfirm}
            color="primary"
            disabled={!userEmail || userAlreadyExist || isInValidEmail}
            onClick={onConfirm}
          >
            {t("button_add")}
          </Button>
        </Grid>
      }
    >
      <Grid display="flex" flexDirection="column" p="20px" gap="20px">
        {/* clinic name field*/}
        <TextField
          id="outlined-basic"
          value={userEmail}
          onChange={handleChange}
          label={t("users_table_email")}
          variant="outlined"
          sx={() => CustomTextFieldOutlined({ mt: 0 })}
          InputProps={{
            sx: CustomTextFieldOutlinedInputProps,
          }}
          inputProps={{ "data-testid": "email-textfield" }}
          error={userAlreadyExist || isInValidEmail}
          helperText={
            userAlreadyExist
              ? t("clinic_same_email_error")
              : isInValidEmail
                ? t("clinic_invalid_email_error")
                : undefined
          }
          color="warning"
          fullWidth
        />
      </Grid>
    </DefaultModal>
  );
};

export default AddUserModal;
